module.exports = __webpack_public_path__ + "assets/flex-logo.ecdfab56.svg";